module.exports = __webpack_public_path__ + "img/a11y-color-naming-1_cn.40bef5a.jpg";